import { Link } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center px-4 md:px-6">
        <div className="max-w-xl mx-auto text-center py-16 md:py-24">
          <p className="font-heading text-7xl md:text-8xl font-bold text-primary-500">
            404
          </p>
          <h1 className="mt-4 text-2xl md:text-3xl font-bold text-foreground-950 tracking-tight">
            Aradığın sayfa bulunamadı
          </h1>
          <p className="mt-3 text-base text-foreground-600 leading-relaxed">
            Sayfa taşınmış veya hiç var olmamış olabilir. Ana sayfaya dönüp yoluna devam
            edebilirsin.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="whitespace-nowrap px-7 py-3.5 rounded-md text-base font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
            >
              Ana sayfaya dön
            </Link>
            <Link
              to="/sinavlar"
              className="whitespace-nowrap px-7 py-3.5 rounded-md text-base font-semibold text-foreground-800 border border-background-300 hover:bg-background-100 transition-colors"
            >
              Sınavları incele
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}